const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  userId: state => state.user.userId,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  employeeId: state => state.user.employeeId,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  userInfo: state => state.user.userInfo,
  userRoles: state => state.user.userRoles
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js